function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.51612 4.67008C7.03971 -1.10593 15.776 1.78913 14.9729 8.46666",
  stroke: "#5FC4B8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9871 9.53856C15.0215 9.58391 15.0823 9.58391 15.1166 9.53856L17.5901 6.26999C17.639 6.20537 17.5995 6.104 17.5254 6.104H12.5784C12.5043 6.104 12.4648 6.20537 12.5137 6.26999L14.9871 9.53856Z",
  fill: "#5FC4B8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1 11.3299C10.5336 17.1059 1.69122 14.2109 2.50411 7.53334",
  stroke: "#5FC4B8",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.65347 6.44833C2.61907 6.4085 2.56269 6.4085 2.52829 6.44833L0.025367 9.34644C-0.0292412 9.40967 0.010086 9.51656 0.0879563 9.51656H5.09381C5.17168 9.51656 5.21101 9.40967 5.1564 9.34644L2.65347 6.44833Z",
  fill: "#5FC4B8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.51099 9.53947C6.5926 10.46 7.34637 11.1127 8.49382 11.1973V11.8689H9.06994V11.1973C10.323 11.0987 11.1008 10.4036 11.1008 9.3751C11.1008 8.49688 10.5775 7.98968 9.46843 7.7032L9.06994 7.59988V5.50061C9.68928 5.56166 10.107 5.89511 10.2126 6.39292H11.024C10.9327 5.51 10.1742 4.876 9.06994 4.80555V4.13867H8.49382V4.81964C7.42318 4.94644 6.68862 5.63211 6.68862 6.56199C6.68862 7.36506 7.22154 7.93332 8.15774 8.17283L8.49382 8.26206V10.4881C7.86008 10.3942 7.42318 10.0467 7.31756 9.53947H6.51099ZM8.38339 7.42142C7.80727 7.27583 7.5 6.96587 7.5 6.52911C7.5 6.00782 7.88889 5.62272 8.49382 5.5194V7.4496L8.38339 7.42142ZM9.26198 8.45461C9.97254 8.63308 10.2846 8.92895 10.2846 9.43145C10.2846 10.0373 9.82851 10.4412 9.06994 10.5022V8.40765L9.26198 8.45461Z",
  fill: "#5FC4B8"
});

var SvgSubscription = function SvgSubscription(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSubscription, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/subscription.2e3b2526.svg";
export { ForwardRef as ReactComponent };